import React, { useRef } from 'react';
import Select from 'react-select';
import { FormGroup } from 'react-bootstrap';
import { customStyles } from '../../../../../Components/helper';
import CommonAction from './CommonAction';

export function DropDown({
  placeholder,
  label,
  name,
  fromForm,
  duplicatingItem,
  gridIndex,
  pageIndex,
  disable,
  editingInput,
  showDelete,
  deleteItem,
  value,
  onChange,
  options,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  setParentGridZIndex,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  boldLabel,
}) {
  const selectRef = useRef(null);

  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  const selectStyle = {
    ...customStyles,
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.7 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, fontSize: 12, opacity, transition };
    },
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      // height: "100%",
      height: '20px',
      borderBottom: '1px solid #848484',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
      color: '#555',
      fontWeight: otherConfiguration?.bold ? 'bold' : 'normal',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#848484',
      fontSize: 12,
    }),
  };

  const handleMenuOpen = () => {
    setParentGridZIndex(true, gridIndex);
  };

  const handleMenuClose = () => {
    setParentGridZIndex(false, gridIndex);
  };
  return (
    <FormGroup className="flex-fill position-relative">
      <div className="custom-react-select-po">
        <p className={`mb-1 fs-custom-module field-lbl asterisk-req ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>{label}</p>
        {fromForm && onElement && (
          <CommonAction
            editingInput={editingInput}
            gridIndex={gridIndex}
            pageIndex={pageIndex}
            showDelete={showDelete}
            deleteItem={deleteItem}
            handleDuplicateItem={handleDuplicateItem}
            supplierVisible={supplierVisible}
            handleSupplierPermission={handleSupplierPermission}
            handleStaticGrid={handleStaticGrid}
            isStatic={isStatic}
          />
        )}
        <Select
          name={name}
          options={options}
          getOptionLabel={(option) => `${option?.name}`}
          getOptionValue={(option) => `${option?.name}`}
          isDisabled={disable}
          inputProps={{
            autoComplete: 'off',
            autoCorrect: 'off',
            spellCheck: 'off',
          }}
          ref={selectRef}
          onMenuOpen={handleMenuOpen}
          onMenuClose={handleMenuClose}
          styles={selectStyle}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e, label, gridIndex, pageIndex)}
        />
      </div>
    </FormGroup>
  );
}
export default DropDown;
